import { render, staticRenderFns } from "./Bottom.vue?vue&type=template&id=71d23829&scoped=true&"
import script from "./Bottom.vue?vue&type=script&lang=ts&"
export * from "./Bottom.vue?vue&type=script&lang=ts&"
import style0 from "./Bottom.vue?vue&type=style&index=0&id=71d23829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d23829",
  null
  
)

export default component.exports